/**
 * Report status values
 */
export enum ReportStatusEnum {
	/**
	 * Report is active
	 */
	ACTIVE = 'active',
	/**
	 * Report is archived
	 */
	ARCHIVED = 'archived',
}
